
// TODO: Add additional as required
export enum DateFormat {
    DDMMYYYY = 'DDMMYYYY',
    MMDDYYYY = 'MMDDYYYY',
    YYYYMMDD = 'YYYYMMDD'
}

export const isDateValid = (dateString: string) => {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
}

// TODO: Add additional as required
export const getFormatedDateAsString = (date: Date, delimiter: string, format = DateFormat.MMDDYYYY): string => {
    const dd = date.getDate();
    const mm = date.getMonth() + 1;
    const yyyy = date.getFullYear();

    switch (format) {
        case DateFormat.DDMMYYYY:
            return `${dd}${delimiter}${mm}${delimiter}${yyyy}`;
        case DateFormat.MMDDYYYY:
            return `${mm}${delimiter}${dd}${delimiter}${yyyy}`;
        case DateFormat.YYYYMMDD:
            return `${yyyy}${delimiter}${mm}${delimiter}${dd}`;
    }
}

export const checkDateValidity = (startingDate: string, closingDate: string) => {
    const startDate = new Date(startingDate);
    const endDate = new Date(closingDate)
    const today = new Date();
    return today < startDate || today > endDate || startDate > endDate;
}

export const findDaysDiffOfTwoDate = (startDate: string | Date, endDate: string | Date) => {
    if (!startDate || !endDate) return null;

    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffInDays = Math.round((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
    return diffInDays;
}

export const getDateWithMonthName = (date: string) => {
    const dd = new Date(date).getDate();
    const mm = new Date(date).toLocaleString('default', { month: 'long' });
    const yyyy = new Date(date).getFullYear();

    return `${mm} ${dd}, ${yyyy}`;
}

export const getHoursMinutes = (date: string) => {
    let dateObj = new Date(date);

    let hrs = dateObj.getHours();
    let mins: any = dateObj.getMinutes();

    let format = hrs >= 12 ? 'PM' : 'AM';
    hrs = hrs % 12;

    // To display "0" as "12"
    hrs = hrs ? hrs : 12;
    mins = mins < 10 ? '0' + mins : mins;

    return hrs + ':' + mins + ' ' + format;
}

/**
 * difference in days from today, 0 will be returned.
 * @param expiryDate Accepted Date Format: "YYYY-MM-DD"
 * @returns integer value, 
 */
export const getDaysDifferenceFromToday = (expiryDate: string) => {
    if (!expiryDate) return -1;

    const givenEpiryDate = expiryDate?.split('-');
    const yyyy = parseInt(givenEpiryDate[0]);
    const mm = parseInt(givenEpiryDate[1]) - 1; // Providing the index for month
    const dd = parseInt(givenEpiryDate[2]);

    // Handling wrong input
    if (isNaN(yyyy) || isNaN(mm) || isNaN(dd) || yyyy.toString()?.length !== 4) {
        return 0;
    }

    const date1 = new Date(yyyy, mm, dd).toISOString(); // Should be Heigher
    const date2 = new Date(Date.now()).toISOString();
    const DAY_UNIT_IN_MILLISECONDS = 24 * 3600 * 1000;

    const diffInMilliseconds = new Date(date1).getTime() - new Date(date2).getTime();
    const diffInDays = diffInMilliseconds / DAY_UNIT_IN_MILLISECONDS;

    return parseInt(diffInDays.toString())
}


/**
 * Formats credit card expiration date to MM/YY format (month always first)
 * @param expDate - Date string in MMYY, YYMM, MM/YY, or YY/MM format
 * @returns Formatted date as MM/YY or original if invalid
 */
export const formatExpirationDate = (expDate: string | null | undefined): string => {
  if (!expDate) return '';
  
  const dateStr = expDate.toString().trim();
  
  // Handle 4-digit format
  if (/^\d{4}$/.test(dateStr)) {
    const part1 = parseInt(dateStr.substring(0, 2));
    const part2 = parseInt(dateStr.substring(2, 4));
    
    if (part1 > 12) {
      return `${part2.toString().padStart(2, '0')}/${part1.toString().padStart(2, '0')}`;
    } else {
      return `${part1.toString().padStart(2, '0')}/${part2.toString().padStart(2, '0')}`;
    }
  }
  
  // Handle slash format
  if (dateStr.includes('/')) {
    const parts = dateStr.split('/');
    const first = parseInt(parts[0]);
    const second = parseInt(parts[1]);
    
    if (first > 12) {
      return `${second.toString().padStart(2, '0')}/${first.toString().padStart(2, '0')}`;
    } else {
      return `${first.toString().padStart(2, '0')}/${second.toString().padStart(2, '0')}`;
    }
  }
  
  return dateStr;
};